module.exports = __webpack_public_path__ + "static/lego-a563a51c98370b924e32523f8c00f662.svg";